import Button from '@mui/material/Button';
import dayjs from 'dayjs';
// import { DatePicker } from 'antd';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux'
import { useCookies } from 'react-cookie'
import { useEffect, useState } from "react"
import { getStyle } from "../../libs/todoSlice";
import React, { useRef } from "react";
import fontColor from "../../lib/fontColor";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getAddEmailColorRedux, getAddEmailRedux, getBirthDayRedux, getDepartmentRedux, getEmailRedux, getIdCardNumberRedux, getLastNameEngRedux, getLastNameThaiRedux, getNameEngRedux, getNameThaiRedux, getOneMailRedux, getPhoneNumberRedux, getPositionRedux, getProfileRedux, getStaffIDRedux, getStepRedux, getTitleEngRedux, getTitleThaiRedux, setAddEmailColorRedux, setAddEmailRedux, setBirthDayRedux, setDepartmentRedux, setEmailRedux, setIdCardNumberRedux, setLastNameEngRedux, setLastNameThaiRedux, setNameEngRedux, setNameThaiRedux, setOneMailRedux, setPhoneNumberRedux, setPositionRedux, setProfileRedux, setStaffIDRedux, setStepRedux, setTitleEngRedux, setTitleThaiRedux } from "../../libs/profileSlice";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { makeStyles } from "@material-ui/core";
import Swal from "sweetalert2";
import Alert from '@mui/material/Alert';



const EditProfile = () => {
    const [cookie, setCookie] = useCookies(['account'])
    const style = useSelector(getStyle)
    const profile = useSelector(getProfileRedux)
    const titleThai = useSelector(getTitleThaiRedux)
    const titleEng = useSelector(getTitleEngRedux)
    const nameThai = useSelector(getNameThaiRedux)
    const nameEng = useSelector(getNameEngRedux)
    const lastnameThai = useSelector(getLastNameThaiRedux)
    const lastnameEng = useSelector(getLastNameEngRedux)
    // const birthday = useSelector(getBirthDayRedux)
    const idCardNumber = useSelector(getIdCardNumberRedux)
    const staffId = useSelector(getStaffIDRedux)
    const position = useSelector(getPositionRedux)
    const department = useSelector(getDepartmentRedux)
    const onemail = useSelector(getOneMailRedux)
    const email = useSelector(getEmailRedux)
    const step = useSelector(getStepRedux)
    const phoneNumber = useSelector(getPhoneNumberRedux)
    const [birthday, setBirthDay] = useState(dayjs(profile.birth_date));
    const [birthdayvalue, setBirthDayValue] = useState('')
    const [addmobile, setAddMobile] = useState(false)
    const [addmobilevalue, setAddMobileValue] = useState('')
    const addemail = useSelector(getAddEmailRedux)
    const [addemailvalue, setAddEmailValue] = useState('')
    const addemailcolor = useSelector(getAddEmailColorRedux)
    const textInputRef = useRef(null);
    const [warnNameThai, setWarnNameThai] = useState(false)
    const [warnLastNameThai, setWarnLastNameThai] = useState(false)
    const [warnNameEng, setWarnNameEng] = useState(false)
    const [warnLastNameEng, setWarnLastNameEng] = useState(false)
    const [warnPhoneNum, setWarnPhoneNum] = useState(false)


    useEffect(() => {
        setIdCardNumber(profile.id_card_num)
        setTitleThai(profile.account_title_th)
        setTitleEng(profile.account_title_eng)
        setNameThai(profile.first_name_th)
        setNameEng(profile.first_name_eng)
        setLastNameThai(profile.last_name_th)
        setLastNameEng(profile.last_name_eng)
        setPosition(profile.role_name)
        setStaffID(profile.employee_id)
        setBirthDay(dayjs(profile.birth_date))
        setDepartment(profile.dept_name)
        setAddMobile(false)
        setAddMobileValue('')
        setAddEmailValue('')
        tranDate(birthday)
    }, []);

    const dispatch = useDispatch()

    const setProfile = (action) => {
        dispatch(setProfileRedux({
            profile: action,
        }))
    }

    const setAddEmail = (action) => {
        dispatch(setAddEmailRedux({
            addemail: action,
        }))
    }

    const setAddEmailColor = (action) => {
        dispatch(setAddEmailColorRedux({
            addemailcolor: action,
        }))
    }


    const setPhoneNumber = (action) => {
        dispatch(setPhoneNumberRedux({
            phoneNumber: action,
        }))
    }

    const setStep = (action) => {
        dispatch(setStepRedux({
            step: action,
        }))
    }

    const setTitleThai = (action) => {
        dispatch(setTitleThaiRedux({
            titleThai: action,
        }))
    }

    const setTitleEng = (action) => {
        dispatch(setTitleEngRedux({
            titleEng: action,
        }))
    }

    const setNameThai = (action) => {
        dispatch(setNameThaiRedux({
            nameThai: action,
        }))
    }

    const setNameEng = (action) => {
        dispatch(setNameEngRedux({
            nameEng: action,
        }))
    }

    const setLastNameThai = (action) => {
        dispatch(setLastNameThaiRedux({
            lastnameThai: action,
        }))
    }

    const setLastNameEng = (action) => {
        dispatch(setLastNameEngRedux({
            lastnameEng: action,
        }))
    }

    // const setBirthDay = (action) => {
    //     dispatch(setBirthDayRedux({
    //         birthday: action,
    //     }))
    // }

    const setIdCardNumber = (action) => {
        dispatch(setIdCardNumberRedux({
            idCardNumber: action,
        }))
    }

    const setStaffID = (action) => {
        dispatch(setStaffIDRedux({
            staffId: action,
        }))
    }

    const setPosition = (action) => {
        dispatch(setPositionRedux({
            position: action,
        }))
    }

    const setDepartment = (action) => {
        dispatch(setDepartmentRedux({
            department: action,
        }))
    }

    const setOneMail = (action) => {
        dispatch(setOneMailRedux({
            onemail: action,
        }))
    }

    const setEmail = (action) => {
        dispatch(setEmailRedux({
            email: action,
        }))
    }

    const tranDate = (value) => {
        const date = new Date(value);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        setBirthDayValue(formattedDate)
    }

    const updateProfile = async () => {
        tranDate(birthday)
        if (addmobilevalue !== "") {
            try {
                await axios({
                    method: 'POST',
                    url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/mobile`,
                    data: {
                        "mobile_no": addmobilevalue
                    }
                })
            } catch (err) {
                Swal.fire({
                    icon: 'error',
                    title: 'เบอร์มือถือซ้ำ หรือเบอร์มือถือไม่ถูกต้อง',
                })
                return false
            }
        }
        if (addemailvalue !== "") {
            try {
                await axios({
                    method: 'POST',
                    url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/email`,
                    data: {
                        "email": addemailvalue
                    }
                })
            } catch (err) {
                Swal.fire({
                    icon: 'error',
                    title: 'อีเมลซ้ำ หรืออีเมลไม่ถูกต้อง',
                })
                return false
            }
        }
        await axios({
            method: 'PATCH',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile`,
            data: {
                "first_name_th": nameThai,
                "last_name_th": lastnameThai,
                "first_name_eng": nameEng,
                "last_name_eng": lastnameEng,
                "account_title_th": titleThai,
                "account_title_eng": titleEng,
                "birth_date": birthdayvalue
            }
        })
            .then(({ data, status }) => {
                localStorage.setItem('account', JSON.stringify({
                    ...JSON.parse(localStorage.getItem('account')),
                    account_title_th: titleThai,
                    first_name_th: nameThai,
                    last_name_th: lastnameThai,
                    account_title_eng: titleEng,
                    first_name_eng: nameEng,
                    last_name_eng: lastnameEng
                }));
                Swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ',
                }).then(() => {
                    window.location.reload();
                })
                setStep("profile")
            }, ({ response, status }) => {
                Swal.fire({
                    icon: 'error',
                    title: 'บันทึกข้อมูลไม่สำเร็จ',
                })
            })
    }


    const useStyles = makeStyles(() => ({
        root: {
            "& .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root": { maxWidth: "240px", height: '36px', marginBottom: '25px' }
        }
    }));

    const a = useStyles();


    const maxDate = dayjs().subtract(7, 'year')


    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;



    return localStorage.getItem('account') && (
        <>

            <div style={{ fontFamily: 'Sarabun', fontWeight: '600', fontSize: '24px', marginBottom: '32px', color: 'black' }}>
                ตั้งค่าข้อมูลพนักงาน
            </div>
            <div style={{ fontFamily: 'Sarabun', fontWeight: '600', fontSize: '20px', marginBottom: '32px', color: 'black' }}>
                ข้อมูลพนักงาน
            </div>
            <div className="row">
                <div className="col">
                    <div style={{ display: 'flex', fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        คำนำหน้า (ไทย) : <div style={{ color: 'red', marginLeft: '5px' }}>*</div>
                    </div>
                    <FormControl
                        style={{ width: '80%', maxWidth: '100px', marginBottom: '24px' }}>
                        <InputLabel labelId="เลือกประเภทฟอร์ม">คำนำหน้า</InputLabel>
                        <Select
                            value={titleThai}
                            labelId="เลือกประเภทฟอร์ม"
                            label='เลือกประเภทฟอร์ม'
                            style={{
                                height: '40px',
                                borderRadius: '6px',
                            }}
                            onChange={(e) => {
                                setTitleThai(e.target.value)
                                if (e.target.value === "นาย") {
                                    setTitleEng("Mr")
                                } else if (e.target.value === "นาง") {
                                    setTitleEng("Mrs")
                                } else if (e.target.value === "นางสาว") {
                                    setTitleEng("Miss")
                                }
                            }}
                        >
                            <MenuItem value="นาย">นาย</MenuItem>
                            <MenuItem value="นาง">นาง</MenuItem>
                            <MenuItem value="นางสาว">นางสาว</MenuItem>
                        </Select>
                    </FormControl>
                    <div style={{ display: 'flex', fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        ชื่อ (ไทย) : <div style={{ color: 'red', marginLeft: '5px' }}>*</div>{warnNameThai === true && <div style={{ color: 'red', marginLeft: '5px' }}>กรุณาใส่ตัวอักษรภาษาไทย</div>}
                    </div>
                    <input value={nameThai}
                        onChange={(e) => {
                            const onlyThai = /^[\u0E00-\u0E7F]+$/
                            if (onlyThai.test(e.target.value) || e.target.value === '') {
                                setNameThai(e.target.value);
                                setWarnNameThai(false)
                            }
                            else {
                                setWarnNameThai(true)
                            }
                        }}
                        style={{ width: '100%', maxWidth: '240px', height: '36px', border: '1px solid #757575', borderRadius: '6px', marginBottom: '24px', padding: '10px' }} />
                    <div style={{ display: 'flex', fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        นามสกุล (ไทย) : <div style={{ color: 'red', marginLeft: '5px' }}>*</div>{warnLastNameThai === true && <div style={{ color: 'red', marginLeft: '5px' }}>กรุณาใส่ตัวอักษรภาษาไทย</div>}
                    </div>
                    <input value={lastnameThai}
                        onChange={(e) => {
                            const onlyThai = /^[\u0E00-\u0E7F]+$/
                            if (onlyThai.test(e.target.value) || e.target.value === '') {
                                setLastNameThai(e.target.value);
                                setWarnLastNameThai(false)
                            }
                            else {
                                setWarnLastNameThai(true)
                            }
                        }}
                        style={{ width: '100%', maxWidth: '240px', height: '36px', border: '1px solid #757575', borderRadius: '6px', marginBottom: '24px', padding: '10px' }} />
                    <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        หมายเลขบัตรประชาชน :
                    </div>
                    <div style={{
                        display: 'flex', width: '100%', maxWidth: '240px', height: '36px', border: '1px solid #EEEEEE',
                        borderRadius: '6px', marginBottom: '24px', padding: '10px', color: '#C7C7C7',
                    }} ><div style={{ color: '#C7C7C7' }}>{idCardNumber}</div>
                    </div>
                    <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '24px', color: "#7E7E7E" }}>
                        แผนก :
                    </div>
                    {department && <div style={{ width: '100%', maxWidth: '240px', height: department.length <= 0 ? '36px' : 'fit-content', border: '1px solid #EEEEEE', borderRadius: '6px', marginBottom: '24px', padding: '5px' }}>
                        {department.map((item) =>
                        (<div style={{ display: 'flex', width: 'fit-content', backgroundColor: '#CAF3DD33', color: '#C7C7C7', borderRadius: '16px', paddingLeft: '5px' }}>
                            <div style={{ fontSize: '16px', marginRight: '8px' }}>·</div> {item}<br />
                        </div>))}
                    </div>}
                    <div style={{ display: 'flex', fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        เบอร์มือถือ : <div style={{ color: 'red', marginLeft: '5px' }}>*</div>{warnPhoneNum === true && <div style={{ color: 'red', marginLeft: '5px' }}>กรุณาใส่เบอร์มือถือ</div>}
                    </div>
                    <div style={{ width: '100%', maxWidth: '240px', height: phoneNumber.length <= 1 ? '36px' : 'fit-content', padding: '10px', border: '1px solid #757575', borderRadius: '6px', marginBottom: '12px' }} >
                        {phoneNumber.map((item) => (<>
                            {item.mobile_no}<br />
                        </>))}</div>
                    <div>
                        {addmobile === true && <input value={addmobilevalue}
                            onChange={(e) => {
                                const onlyPhoneNumber = /^0\d{0,9}$/
                                if (onlyPhoneNumber.test(e.target.value) || e.target.value === '') {
                                    setAddMobileValue(e.target.value)
                                    setWarnPhoneNum(false)
                                }
                                else {
                                    setWarnPhoneNum(true)
                                }
                            }}
                            style={{ width: '100%', maxWidth: '240px', height: '36px', border: '1px solid #757575', borderRadius: '6px', marginBottom: '12px', padding: '10px' }} />}
                        {addmobile === false && <button
                            onClick={() => { setAddMobile(true) }}
                            style={{
                                width: '140px',
                                height: '35px',
                                marginTop: '7px',
                                marginBottom: '24px',
                                border: 'none',
                                backgroundColor: 'white',
                                fontFamily: 'Sarabun',
                                fontWeight: '500',
                                fontSize: '16px'
                            }}
                        >
                            <AddCircleOutlineIcon
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    marginRight: '5px',
                                    color: style.primary_color
                                }} />เพิ่มเบอร์มือถือ
                        </button>}
                    </div>
                    <div style={{ display: 'flex', fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        อีเมล : <div style={{ color: 'red', marginLeft: '5px' }}>*</div>{emailRegex.test(addemailvalue) === true || addemail === false || addemailvalue === '' ? null : <div style={{ color: 'red', marginLeft: '5px' }}>กรุณาใส่อีเมลให้ถูกต้อง</div>}
                    </div>
                    <div style={{ width: '100%', maxWidth: '240px', height: email.length <= 1 ? '36px' : 'fit-content', border: '1px solid #757575', borderRadius: '6px', marginBottom: '12px', padding: '10px' }} >
                        {email.map((item) => (<>
                            {item.email}<br />
                        </>))}</div>
                    <div>
                        {(() => {
                            if (addemail === true && addemailcolor === false) {
                                return (<input value={addemailvalue} ref={textInputRef}
                                    onChange={(e) => {
                                        setAddEmailValue(e.target.value)
                                    }}

                                    style={{ width: '100%', maxWidth: '240px', height: '36px', border: '1px solid #757575', borderRadius: '6px', marginBottom: '12px', padding: '10px' }} />
                                )
                            }
                            else if (addemail === true && addemailcolor === true) {
                                return (<><div style={{ color: 'red', fontSize: '14px', marginBottom: '5px' }}>* กรุณากรอกข้อมูล</div><input value={addemailvalue}
                                    onClick={() => {
                                        setAddEmailColor(false)
                                        textInputRef.current.focus()
                                    }} onChange={(e) => { setAddEmailValue(e.target.value) }} ref={textInputRef} style={{ width: '100%', maxWidth: '240px', height: '36px', border: `1px solid ${style.primary_color}`, borderRadius: '6px', marginBottom: '12px', padding: '10px' }} />
                                </>)
                            }
                        })()}
                        {addemail === false && <button
                            onClick={() => {
                                setAddEmail(true)
                            }}
                            style={{
                                width: '105px',
                                height: '35px',
                                marginTop: '7px',
                                marginBottom: '24px',
                                border: 'none',
                                backgroundColor: 'white',
                                fontFamily: 'Sarabun',
                                fontWeight: '500',
                                fontSize: '16px'
                            }}
                        >
                            <AddCircleOutlineIcon
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    marginRight: '5px',
                                    color: style.primary_color
                                }} />เพิ่มอีเมล
                        </button>}
                    </div>
                </div>
                <div className="col">
                    <div style={{ display: 'flex', fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        คำนำหน้า (อังกฤษ) : <div style={{ color: 'red', marginLeft: '5px' }}>*</div>
                    </div>
                    <FormControl
                        style={{ width: '80%', maxWidth: '100px', marginBottom: '24px' }}>
                        <InputLabel labelId="เลือกประเภทฟอร์ม">คำนำหน้า</InputLabel>
                        <Select
                            value={titleEng}
                            labelId="เลือกประเภทฟอร์ม"
                            label='เลือกประเภทฟอร์ม'
                            style={{
                                height: '40px',
                                borderRadius: '6px',
                            }}
                            onChange={(e) => {
                                setTitleEng(e.target.value)
                                if (e.target.value === "Mr") {
                                    setTitleThai("นาย")
                                } else if (e.target.value === "Mrs") {
                                    setTitleThai("นาง")
                                } else if (e.target.value === "Miss") {
                                    setTitleThai("นางสาว")
                                }
                            }}
                        >
                            <MenuItem value="Mr">Mr.</MenuItem>
                            <MenuItem value="Mrs">Mrs.</MenuItem>
                            <MenuItem value="Miss">Miss</MenuItem>
                        </Select>
                    </FormControl>
                    <div style={{ display: 'flex', fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        ชื่อ (อังกฤษ) : <div style={{ color: 'red', marginLeft: '5px' }}>*</div>{warnNameEng === true && <div style={{ color: 'red', marginLeft: '5px' }}>กรุณาใส่ตัวอักษรอังกฤษ</div>}
                    </div>
                    <input value={nameEng}
                        onChange={(e) => {
                            const onlyEng = /^[A-Za-z]+$/
                            if (onlyEng.test(e.target.value) || e.target.value === '') {
                                setNameEng(e.target.value);
                                setWarnNameEng(false)
                            }
                            else {
                                setWarnNameEng(true)
                            }
                        }} style={{ width: '100%', maxWidth: '240px', height: '36px', border: '1px solid #757575', borderRadius: '6px', marginBottom: '24px', padding: '10px' }} />
                    <div style={{ display: 'flex', fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        นามสกุล (อังกฤษ) : <div style={{ color: 'red', marginLeft: '5px' }}>*</div>{warnLastNameEng === true && <div style={{ color: 'red', marginLeft: '5px' }}>กรุณาใส่ตัวอักษรอังกฤษ</div>}
                    </div>
                    <input value={lastnameEng}
                        onChange={(e) => {
                            const onlyEng = /^[A-Za-z]+$/
                            if (onlyEng.test(e.target.value) || e.target.value === '') {
                                setLastNameEng(e.target.value);
                                setWarnLastNameEng(false)
                            }
                            else {
                                setWarnLastNameEng(true)
                            }
                        }}
                        style={{ width: '100%', maxWidth: '240px', height: '36px', border: '1px solid #757575', borderRadius: '6px', marginBottom: '24px', padding: '10px' }} />
                    <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        รหัสพนักงาน :
                    </div>
                    <div style={{
                        display: 'flex', width: '100%', maxWidth: '240px', height: '36px', border: '1px solid #EEEEEE',
                        borderRadius: '6px', marginBottom: '24px', padding: '10px', color: '#C7C7C7',
                    }} ><div style={{ color: '#C7C7C7' }}>{staffId}</div>
                    </div>
                    <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '24px', color: "#7E7E7E" }}>
                        อีเมลหลัก :
                    </div>
                    <div style={{
                        display: 'flex', width: '100%', maxWidth: '240px', height: '36px', border: '1px solid #EEEEEE',
                        borderRadius: '6px', marginBottom: '24px', padding: '10px', color: '#C7C7C7',
                    }} ><div style={{ color: '#C7C7C7' }}>{onemail.email}</div>
                    </div>
                </div>
                <div className="col">
                    <div style={{ display: 'flex', fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '2px', color: "#7E7E7E" }}>
                        วัน / เดือน / ปีเกิด : <div style={{ color: 'red', marginLeft: '5px' }}>*</div>
                    </div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                            <DatePicker
                                views={['day', 'month', 'year']}
                                format="DD-MM-YYYY"
                                maxDate={maxDate}
                                value={birthday}
                                className={a.root}
                                onChange={(newValue) => {
                                    setBirthDay(newValue)
                                    tranDate(newValue)
                                }} />
                        </DemoContainer>
                    </LocalizationProvider>
                    <div style={{ fontFamily: 'Sarabun', fontWeight: '400', fontSize: '14px', marginBottom: '12px', color: "#7E7E7E" }}>
                        ตำแหน่ง :
                    </div>
                    <div style={{ width: '100%', maxWidth: '240px', height: position.length <= 0 ? '36px' : 'fit-content', border: '1px solid #EEEEEE', borderRadius: '6px', marginBottom: '24px', padding: '5px' }}>
                        {position.map((item) =>
                        (<div style={{ display: 'flex', width: 'fit-content', backgroundColor: '#CAF3DD33', color: '#C7C7C7', borderRadius: '16px', paddingLeft: '5px' }}>
                            <div style={{ fontSize: '16px', marginRight: '8px' }}>·</div> {item}<br />
                        </div>))}
                    </div>
                </div>
            </div>
            {nameThai === "" || nameEng === "" || titleThai === "" || titleEng === "" ||
                lastnameThai === "" || lastnameEng === "" || birthday === "" ?
                <Alert /* variant="outlined" */ severity="error" style={{ marginBottom: '10px', width: '100%', maxWidth: '250px' }}>กรุณากรอกข้อมูลให้ครบถ้วน</Alert> : <></>}
            <div className="row">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '30px',
                    }}>
                    <Button
                        variant="outlined"
                        style={{
                            marginTop: '15px',
                            width: '156px',
                            height: '36px',
                            marginRight: '10px',
                            borderColor: style.primary_color,
                            color: '#000000'
                        }}
                        onClick={() => { setStep("profile") }}
                    >ยกเลิก</Button>
                    <Button
                        disabled={nameThai === "" || nameEng === "" || titleThai === "" || titleEng === "" ||
                            lastnameThai === "" || lastnameEng === "" || birthday === null || warnNameThai === true || warnNameEng === true
                            || warnLastNameThai === true || warnLastNameEng === true || warnPhoneNum === true ||
                            warnPhoneNum === false && addmobilevalue.length !== 10 && addmobilevalue !== '' ||
                            emailRegex.test(addemailvalue) === false && addemail === true && addemailvalue !== ''
                        }
                        variant="contained"
                        style={{
                            marginTop: '15px',
                            width: '156px',
                            height: '36px',
                            backgroundColor: style.primary_color,
                            color: fontColor(style.primary_color),
                        }}
                        onClick={updateProfile}
                    >บันทึก</Button>
                </div>
            </div>

        </>
    )
}

export default EditProfile